// extracted by css-extract-rspack-plugin
export default {"error":"UAEdF5fVWVQkUu9H"};